export default __webpack_public_path__ + "static/media/Corporativo Neuchatel .0882f42b.pdf";